import {
  UpdateUserResponse,
  SubOrganization as ModelsSubOrganization,
  Venue as ModelsVenue,
  Organization as ModelsOrganization,
  CreateUserResponse,
  VenueBranch as ModelsVenueBranch,
  VisitType,
  Location,
  Sweep as SweepModel,
} from '@inplay/models';

export enum StorageKey {
  ACCESS_TOKEN = 'accessToken',
  SESSION_ID = 'sessionId',
  STAFF_ACCESS_TOKEN = 'staffAccessToken',
  STAFF_REFRESH_TOKEN = 'staffRefreshToken',
  EXPIRY_TIME = 'expiryTime',
  MUST_ACCEPT_TNC = 'mustAcceptTnC',
  REFRESH_TOKEN = 'refreshToken',
  VENUE_ID = 'venueId',
  STAFF_PIN = 'staffPin',
  VENUE_UNIT_DETAILS = 'venueUnitDetails',
  ORGANIZATION_UNIT_DATA = 'organizationUnitDatas',
  IDP_TOKEN = 'idpToken',
  DEVICE_ID = 'deviceId',
}

export enum EnvVariables {
  BASE_URL = 'REACT_APP_BASE_URL',
  REACT_APP_PLAYER_VISITS_API_RESOURCE = 'REACT_APP_PLAYER_VISITS_API_RESOURCE',
  REACT_APP_HOURLY_API_RESOURCE = 'REACT_APP_HOURLY_API_RESOURCE',
  REACT_APP_ATM_USER_API_RESOURCE = 'REACT_APP_ATM_USER_API_RESOURCE',
  REACT_APP_LOGOUT_RESOURCE = 'REACT_APP_LOGOUT_RESOURCE',
  REACT_APP_LOGIN_RESOURCE = 'REACT_APP_LOGIN_RESOURCE',
  REACT_APP_EMPLOYEE_SWEEPS_API_RESOURCE = 'REACT_APP_EMPLOYEE_SWEEPS_API_RESOURCE',
  REACT_APP_VISIT_API_RESOURCE = 'REACT_APP_VISIT_API_RESOURCE',
  REACT_APP_FORGOT_PASSWORD_RESOURCE = 'REACT_APP_FORGOT_PASSWORD_RESOURCE',
  REACT_APP_RESET_PASSWORD_RESOURCE = 'REACT_APP_RESET_PASSWORD_RESOURCE',
  REACT_APP_VERIFY_OTP_RESOURCE = 'REACT_APP_VERIFY_OTP_RESOURCE',
  REACT_APP_SALT_RESOURCE = 'REACT_APP_SALT_RESOURCE',
  REACT_APP_NEW_PASSWORD = 'REACT_APP_NEW_PASSWORD',
  REACT_APP_ACCEPT_TERMS = 'REACT_APP_ACCEPT_TERMS',
  REACT_APP_VERSION = 'REACT_APP_VERSION',
  REACT_APP_USERS_RESOURCE = 'REACT_APP_USERS_RESOURCE',
  REACT_APP_ORGANIZATION_UNIT_RESOURCE = 'REACT_APP_ORGANIZATION_UNIT_RESOURCE',
  REACT_APP_RESEND_EMAIL_RESOURCE = 'REACT_APP_RESEND_EMAIL_RESOURCE',
  REACT_APP_GET_USER_DETAIL_RESOURCE = 'REACT_APP_GET_USER_DETAIL_RESOURCE',
  REACT_APP_REFRESH_TOKEN_RESOURCE = 'REACT_APP_REFRESH_TOKEN_RESOURCE',
  REACT_APP_ACTIVATE_DEACTIVATE_USER_RESOURCE = 'REACT_APP_ACTIVATE_DEACTIVATE_USER_RESOURCE',
  REACT_APP_COMPLETE_ONBOARDING_RESOURCE = 'REACT_APP_COMPLETE_ONBOARDING_RESOURCE',
  REACT_APP_DELETE_USER_RESOURCE = 'REACT_APP_DELETE_USER_RESOURCE',
  REACT_APP_CREATE_ORGANIZATION_RESOURCE = 'REACT_APP_CREATE_ORGANIZATION_RESOURCE',
  REACT_APP_VENUE_UPDATE_RESOURCE = 'REACT_APP_VENUE_UPDATE_RESOURCE',
  REACT_APP_CREATE_USER_RESOURCE = 'REACT_APP_CREATE_USER_RESOURCE',
  REACT_APP_UPDATE_PROFILE_RESOURCE = 'REACT_APP_UPDATE_PROFILE_RESOURCE',
  REACT_APP_UPDATE_USER_RESOURCE = 'REACT_APP_UPDATE_USER_RESOURCE',
  REACT_APP_CHANGE_USER_PROFILE_RESOURCE = 'REACT_APP_CHANGE_USER_PROFILE_RESOURCE',
  REACT_APP_GET_SWEEPS = 'REACT_APP_GET_SWEEPS',
  REACT_APP_GET_VENUE_OPENING_HOURS = 'REACT_APP_GET_VENUE_OPENING_HOURS',
  REACT_APP_SWEEP_UPDATE = 'REACT_APP_SWEEP_UPDATE',
  REACT_APP_APPROVE_SWEEP_REPORT = 'REACT_APP_APPROVE_SWEEP_REPORT',
  REACT_APP_DELETE_SWEEPS_RESOURCE = 'REACT_APP_DELETE_SWEEPS_RESOURCE',
  REACT_APP_DOWNLOAD_SWEEPS_RESOURCE = 'REACT_APP_DOWNLOAD_SWEEPS_RESOURCE',
  REACT_APP_GET_SWEEP_HISTORY_RESOURCE = 'REACT_APP_GET_SWEEP_HISTORY_RESOURCE',
  REACT_APP_AUTH_USERS_RESOURCE = 'REACT_APP_AUTH_USERS_RESOURCE',
  REACT_APP_HARM_REPORT_RESOURCE = 'REACT_APP_HARM_REPORT_RESOURCE',
  REACT_APP_INTERVENTION_REPORT_RESOURCE = 'REACT_APP_INTERVENTION_REPORT_RESOURCE',
  REACT_APP_SEND_USER_VERIFICATION_CODE_RESOURCE = 'REACT_APP_SEND_USER_VERIFICATION_CODE_RESOURCE',
  REACT_APP_VERIFY_USER_VERIFICATION_CODE = 'REACT_APP_VERIFY_USER_VERIFICATION_CODE',
  REACT_APP_NOTIFICATION_SUBSCRIPTION_RESOURCE = 'REACT_APP_NOTIFICATION_SUBSCRIPTION_RESOURCE',
}

export type ApiErrorResponse = {
  data: {
    statusCode: number;
    status: string;
    message: string;
  };
};

export type DownloadStatusResponse = {
  statusCode: number;
  data: string[];
};

export type StatusResponse = {
  statusCode: number;
  data: UpdateUserResponse;
};

export type CreateUserStatusResponse = {
  statusCode: number;
  data: CreateUserResponse;
};

export type SweepStatusResponse = {
  statusCode: number;
  data: Sweep[];
};

export type ApiError = {
  response: ApiErrorResponse;
};

export enum ToggleKey {
  PLAYERS = 'Players',
  ATM = 'ATM',
}

export enum HeaderKey {
  Image = 'Image',
  Description = 'Description',
  TotalINGamingRoom = 'Time in Gaming Room (Current Uninterrupted | Total)',
  TotalOutGamingRoom = 'Total Time Outside Gaming Room',
  FirstEntered = 'First Entered',
  LastExited = 'Last Exited',
  Actions = 'Actions',
  TotalWithdrawals = 'Total Withdrawals',
  GamingUseTotal = 'Gaming Use Total',
  NonGamingUseTotal = 'Non-Gaming Use Total',
  ATMUse = 'ATM Use (Gaming)',
}

export enum PlayerApiKey {
  TotalWithdraw = 'totalWithdrawals',
  Image = 'image',
  Description = 'description',
  GamingInMinute = 'minutesInGamingRoom',
  GamingOutSideMinute = 'minutesOutsideGamingRoom',
  FirstEntered = 'firstEntered',
  LastExited = 'lastExited',
  HarmObserved = 'harmObserved',
  TotalWithDrawals = 'totalWithdrawals',
  GamingUseCount = 'gamingUseCount',
  NonGamingUseCount = 'nonGamingUseCount',
  IsInGamingRoom = 'isInGamingRoom',
  CurrentUninterruptedMinutes = 'currentUninterruptedMinutes',
}

export enum PlayerCardTitle {
  TotalPlayer = 'Total Players',
  AveragePlayer = 'Average Player Time in Gaming Room',
  RiskHarm = 'Risk / Harm Observed',
  SweepsConducted = 'Sweeps Conducted Today',
  Totalatm = 'Total ATM Uses Today',
  UniqueAtm = 'Unique ATM Users',
  UserWithDraw = 'Users with 2+ Withdrawals',
}

export type GamingNonGamingTotalValue = {
  totalGaming: number;
  totalNonGaming: number;
};

export enum ChartType {
  Line = 'line',
  Bar = 'bar',
}

export enum PlayerStatus {
  LIVE = 'LIVE',
  NOT_LIVE = 'NOT_LIVE',
}

export enum PlayerActionColumnValue {
  INTERVENTION_REQUIRED = 'Intervention Required',
}

export enum LoadMoreButtonText {
  LOAD_MORE_BUTTON = 'Load more data',
}

export type PlayerChartItem = {
  time: string;
  players: number;
};

export enum PlayerPageLimit {
  LIMIT = 10,
}

export enum DefaultLng {
  FRENCH = 'fr',
  ENGLISH = 'en',
}

export type PlayerChartTranslation = {
  hourlyTrafficTitle: string;
  atmUsageTitle: string;
  totalUniquePlayer: string;
  gamingNonGamingTitle: string;
  totalAtmUse: string;
  gamingUse: string;
  nonGamingUse: string;
  gamingDescription: string;
};

export type LoginPlaceholder = {
  email: string;
  password: string;
};

export enum LoginToggleKey {
  STAFF = 'Staff',
  ADMIN = 'Admin',
}

export type LoginTranslation = {
  email: string;
  password: string;
};

export const OTPLength = 6;
export const StaffPinLength = 4;
export const ErrorMessages = {
  PASSWORD_MISMATCH: 'Passwords do not match. Please try again.',
  PASSWORD_FAILED: 'Failed to reset password.',
  PASSWORD_INVALID:
    'Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character. It must not start or end with a space.',
  INVALID_CREDENTIALS:
    'The email or password you entered is incorrect. Please try again.',
  UNEXPECTED_ERROR: 'An unexpected error occurred. Please try again later.',
  INCORRECT_OTP: 'Incorrect OTP. Please try again.',
  DEACTIVATE:
    'Your account has been deactivated. Please contact your administrator.',

  // user form field validation errors
  USER_TYPE_REQUIRED: 'User type is required.',
  FIRST_NAME_REQUIRED: 'First name is required.',
  LAST_NAME_REQUIRED: 'Last name is required.',
  VENUE_BRANCH_REQUIRED: 'Venue branch is required.',
  EMAIL_REQUIRED: 'Email is required.',
  EMAIL_INVALID: 'Valid email is required.',
};

export const apiStatusCode = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  INTERNAL_SERVER: 500,
  NOT_FOUND: 404,
  EXPIRED_ACCESS_TOKEN: 419,
};

export const StatusText = {
  DELETE: 'delete',
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
};

export const SuccessMessage = {
  RESET_PASSWORD_SUCCESS: 'Password reset successfully.',
  NEW_PASSWORD_SUCCESS: 'New password created successfully.',
  DELETE_SUCCESSFULLY: 'User deleted successfully',
  ACTIVATE_SUCCESSFULLY: 'User activated successfully',
  DEACTIVATE_SUCCESSFULLY: 'User deactivated successfully',
  CHANGE_PASSWORD_SUCCESS: 'Password reset successfully',
  UNIVERSAL_STAFF_LOGIN_PASSWORD_CHANGED_SUCCESSFULLY:
    'Universal staff login updated successfully.',
  VENUE_BRANCH_CREATED_SUCCESSFULLY: 'New venue branch created',
  APPROVE_SINGLE_REPORT_SUCCESSFULLY: 'Report approved successfully',
  APPROVE_MULTIPLE_REPORT_SUCCESSFULLY: 'Report(s) approved successfully',
  DELETE_REPORT_SUCCESSFULLY: 'Report(s) deleted successfully.',
  DELETE_ERROR: 'An error occurred. Please try again.',

  ALREADY_APPROVE:
    'Some of the reports had already been approved. Successfully approved rest of the reports',
};

export type ResetPasswordQuery = {
  code: string | null;
  email: string | null;
};

export type SubOrganization = {
  _id: string;
} & ModelsSubOrganization;

export enum VisitActivityType {
  SESSION = 'session',
  BREAK = 'break',
}

export type ParsedVisitGamblingActivity = {
  type: VisitActivityType;
  startTime: string | Date;
  endTime: string | Date | null;
  timeInMinutes: number;
  name: string;
  miniBreaks?: number[];
};

export type ParsedATMVisit = {
  visitType: VisitType;
  location: Location;
  startTime: string | Date;
  endTime: string | Date | null;
  firstGamingSessionStartTime: string | Date | null;
  poiClassification: string;
  name: string;
};

export type Venue = {
  _id: string;
} & ModelsVenue;

export type Organization = {
  _id: string;
} & ModelsOrganization;

export type VenueBranch = {
  _id: string;
} & ModelsVenueBranch;

export type OrgUnit = Organization | SubOrganization | Venue | VenueBranch;

export enum FilterKey {
  DATE_RANGE = 'dateRange',
  Active = 'active',
}

export type Sweep = SweepModel & { _id: string };

export type UserMenuOption = {
  label: string;
};
